module.exports = __webpack_public_path__ + "img/loader.8965ba9d.svg";